/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import moment from 'moment';
import _ from 'underscore';

import { contains } from '@trello/dom';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { ModelCache } from 'app/scripts/db/ModelCache';
import { Dates } from 'app/scripts/lib/dates';
import { Util } from 'app/scripts/lib/util';
import type { ActionList } from 'app/scripts/models/collections/ActionList';
import { ActionView } from 'app/scripts/views/action/ActionView';
import { CommentActionView } from 'app/scripts/views/action/CommentActionView';
import { View } from 'app/scripts/views/internal/View';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const same = (model: any) => (cancel: any) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (a: any, b: any) {
    const isSameModel = model in a && model in b && a[model].id === b[model].id;
    if (isSameModel) {
      return cancel(a, b);
    } else {
      return [false, false];
    }
  };

// eslint-disable-next-line @trello/no-module-logic
const sameCard = same('card');
// eslint-disable-next-line @trello/no-module-logic
const sameBoard = same('board');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const dup = (a: any) => [a, a];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const doubleOr = function (...args: any[]) {
  const [a, b] = Array.from(args[0]),
    [c, d] = Array.from(args[1]);
  return [a || c, b || d];
};

// @ts-expect-error TS(7023): 'has' implicitly has return type 'any' because it ... Remove this comment to see the full error message
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const has = function (keypath: any, obj: any) {
  if (obj == null) {
    return false;
  }
  if (keypath.length === 0) {
    return true;
  }
  const [head, ...tail] = Array.from(keypath);
  // @ts-expect-error
  return has(tail, obj[head]);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const have = (keypath: any, ...objs: any[]) =>
  _.all(objs, (obj) => has(keypath, obj));
const cancelingPairs = [
  {
    a: 'removeMemberFromCard',
    b: 'addMemberToCard',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
    cancel: sameCard((a: any, b: any) => dup(a.idMember === b.idMember)),
  },
  {
    a: 'deleteAttachmentFromCard',
    b: 'addAttachmentToCard',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
    cancel: sameCard((a: any, b: any) =>
      dup(a.attachment.id === b.attachment.id),
    ),
  },
  {
    a: 'updateCheckItemStateOnCard',
    b: 'updateCheckItemStateOnCard',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
    cancel: sameCard((a: any, b: any) =>
      dup(a.checkItem.id === b.checkItem.id),
    ),
  },
  {
    a: 'updateCard',
    b: 'updateCard',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
    cancel: sameCard((a: any, b: any) =>
      dup(
        'listAfter' in a &&
          'listBefore' in b &&
          a.listAfter.id === b.listBefore.id,
      ),
    ),
  },
  {
    a: 'addChecklistToCard',
    b: 'removeChecklistFromCard',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
    cancel: sameCard((a: any, b: any) =>
      dup(a.checklist.id === b.checklist.id),
    ),
  },
  {
    a: 'updateBoard',
    b: 'updateBoard',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @trello/no-module-logic
    cancel: sameBoard((a: any, b: any) => [
      have(['board', 'prefs', 'background'], a, b),
      false,
    ]),
  },
];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const shouldCancel = (a: any, b: any) =>
  cancelingPairs.reduce(
    // @ts-expect-error
    function (val, pair) {
      if (a.type !== pair.a || b.type !== pair.b) {
        return val;
      } else {
        return doubleOr(val, pair.cancel(a, b));
      }
    },
    [false, false],
  );
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const removeCanceled = function (actions: any) {
  if (actions.length === 1) {
    return actions;
  }

  const canceled = {};
  const iterable = actions.slice(0, -1);
  for (let ixA = 0; ixA < iterable.length; ixA++) {
    const actionA = iterable[ixA];
    const dataA = actionA.toJSON();
    const dataB = actions[ixA + 1].toJSON();
    Object.assign(dataA, dataA.data);
    Object.assign(dataB, dataB.data);

    if (
      dataA.idMemberCreator === dataB.idMemberCreator &&
      moment(dataA.date).diff(dataB.date, 'minutes') < 5 &&
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      !canceled[dataA.id] &&
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      !canceled[dataB.id]
    ) {
      // @ts-expect-error
      const [cancelA, cancelB] = Array.from(shouldCancel(dataA, dataB));
      if (cancelA) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        canceled[dataA.id] = true;
      }
      if (cancelB) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        canceled[dataB.id] = true;
      }
    }
  }

  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  return _.reject(actions, (action) => canceled[action.id]);
};
export interface ActionListView {
  _lastShowDetails: boolean;
  actionViews: ActionView[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  appendSubview: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  highlight: any;
  makeDebouncedMethods(...args: string[]): void;
  removeSubviews(): void;
  renderDebounced(): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderOpts: any;
  showDetails: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  subview: any;
}

export class ActionListView extends View<ActionList> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialize({ renderOpts, highlight }: any) {
    this.renderOpts = renderOpts;
    this.highlight = highlight;
    this.makeDebouncedMethods('render');
    this.listenTo(this.collection, 'add reset', this.renderDebounced);
    this.listenTo(this.collection, 'remove', () => {
      // ensure the comment view is removed from the DOM before rerendering
      this.removeActionViews();
      return this.renderDebounced();
    });
    this.actionViews = [];
    return (this.showDetails = true);
  }

  render() {
    return (
      this.collection
        // @ts-expect-error
        ._getRelatedBoards()
        .then(() => {
          const rerenderAll =
            this.$el.html() === '' ||
            this.showDetails !== this._lastShowDetails ||
            this.missingViews();
          this._lastShowDetails = this.showDetails;
          this.rerender(rerenderAll, true);
        })
        .then(() => {
          this.trigger('render');
        })
        .done()
    );
  }

  missingViews() {
    // We can lose a view when an action is deleted; if we don't reset anything
    // then we'll do dumb things like trying to insert an action before something
    // that isn't in the DOM anymore
    return _.any(this.actionViews, (view) => {
      return !contains(this.el, view.el);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sortActions(allActions: any) {
    return (allActions = _.sortBy(allActions, (a) =>
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      Dates.parse(a.get('date')),
    ).reverse());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rerender(rerenderAll: any, removeExisting: any) {
    const [editTexts, cursorPos] = Array.from(this.saveEdits());

    let allActions = this.collection.models;

    // In some cases, the updates to the collection are being frame debounced
    // (i.e. they won't happen until the tab becomes visible, which could be
    // a long time after they happen).  Filter out any actions that have
    // been deleted - we'd crash if we tried to render them.
    allActions = allActions.filter(
      (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        action: any, // Hasn't be destructed
      ) =>
        action.attributes !== undefined &&
        // Is a placeholder, or is still in the model cache
        (!action.id || ModelCache.get('Action', action.id) !== undefined),
    );

    allActions = this.sortActions(allActions);
    if (!this.showDetails) {
      allActions = _.filter(allActions, (a) => a.isCommentLike());
    }

    const actionList = removeCanceled(allActions).slice(
      0,
      this.renderOpts.limit,
    );
    // Rendering an action should happen:
    // 1. When all the actions need to be rerendered. This is handled
    //    separately for append efficiency
    // 2. When it is a new action added to the action list. All current actions
    //    shouldn't rerender
    // 3. When an action is replaced with another action. All current actions
    //    shouldn't rerender
    //
    // Rerendering should not happen:
    // 1. When a comment action is deleted, unless (in the case of the sidebar)
    //    a new action fills its place.

    if (rerenderAll && removeExisting) {
      this.removeActionViews();
    }

    // Add an empty message for board member profiles.
    $('.js-board-member-profile-no-activity', this.$el).toggleClass(
      'hide',
      actionList.length > 0,
    );

    for (let index = 0; index < actionList.length; index++) {
      const action = actionList[index];
      if (rerenderAll || this.actionNeedsRerender(action, index)) {
        const view = this.rerenderAction(action, index, actionList, {
          rerenderAll,
        });
        this.restoreEdits(editTexts, cursorPos, view);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setShowDetails(value: any) {
    return (this.showDetails = value);
  }

  // Attempts to save in-progress comment edits
  saveEdits() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const editTexts: any = [];
    let cursorPos = 0;
    $('.editing textarea', this.$el).each(function () {
      // eslint-disable-next-line @trello/enforce-variable-case
      const $textarea = $(this);
      editTexts.push($textarea.val());
      if ($textarea.is(':focus')) {
        $textarea.parents('.editing').addClass('focused');
        cursorPos = Util.getCaretPosition($textarea);
      }
    });

    if (editTexts != null) {
      editTexts.reverse();
    }

    return [editTexts, cursorPos];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  restoreEdits(editTexts: any, cursorPos: any, view: any) {
    if (view.$el.hasClass('editing')) {
      $('textarea', view.$el).val(editTexts.pop());
      const textarea = Util.getElem($('textarea', view.$el));
      if (view.$el.hasClass('focused')) {
        Util.setCaretPosition(textarea, cursorPos);
      }
      return view.openEditView();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _viewForAction(action: any) {
    if (/^comment/.test(action.get('type'))) {
      return this.subview(CommentActionView, action, this.renderOpts);
    } else {
      return this.subview(ActionView, action, this.renderOpts);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rerenderAction(action: any, index: any, actionList: any, options: any) {
    const view = this._viewForAction(action);

    const isHighlighted = this.highlight && this.highlight === action.id;
    view.setHighlighted(isHighlighted);

    if (options.rerenderAll) {
      this.appendSubview(view);
      this.actionViews.push(view);
    } else {
      this.insertActionView(view, index);

      // If this is the last view being rendered, just replace the current view
      // at index with this one. Special case is when there's only one actionView
      // and it's being replaced because we can't check if the next action in
      // actionList matches the next actionView
      if (this.actionViews.length === 1 && actionList.length === 1) {
        this.actionViews[index].remove();
        this.actionViews.splice(index, 1, view);
      } else if (this.actionViews[index + 1] == null) {
        this.actionViews.splice(index, 1, view);
      } else if (actionList.length <= this.actionViews.length) {
        // If there aren't more actions in actionList than currently rendered,
        // we need to remove some views
        // If the next action in actionList matches the next actionView,
        // then we should replace the current actionView with the rerendered
        // actionView
        if (
          this.actionViews[index + 1].model.id ===
          // @ts-expect-error TS(2571): Object is of type 'unknown'.
          _.first(actionList[index + 1])?.id
        ) {
          this.actionViews[index].remove();
          this.actionViews.splice(index, 1, view);
        } else {
          // If the view isn't replacing the one already in that place,
          // then remove a view from the end instead.
          this.actionViews.splice(index, 0, view);
          this.actionViews[this.actionViews.length - 1]?.remove();
          this.actionViews = this.actionViews.splice(
            0,
            this.actionViews.length - 1,
          );
        }
      } else {
        this.actionViews.splice(index, 0, view);
      }
    }

    return view;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  actionNeedsRerender(action: any, index: any) {
    // Sometimes when actionViews are created with client only codepaths, the id
    // of the actionView is undefined. Comparing an undefined id to an undefined
    // next actionView would remove the actionView, disconnecting its events. To
    // fix this, we check the cid attribute when there is no id.
    const idKey = action.id != null ? 'id' : 'cid';
    // If the next actionView corresponds to the current model, then the action
    // for the current actionView must have been removed
    if (this.actionViews[index + 1]?.model?.[idKey] === action[idKey]) {
      this.actionViews[index].remove();
      this.actionViews.splice(index, 1);
    }

    const actionView = this.actionViews[index];

    return !actionView || action[idKey] !== actionView.model[idKey];
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  insertActionView(view: any, position: any) {
    if (this.actionViews[position]) {
      view.delegateEvents();
      return view.render().$el.insertBefore(this.actionViews[position].el);
    } else {
      return this.appendSubview(view);
    }
  }

  removeActionViews() {
    this.removeSubviews();
    this.actionViews = [];
  }

  delegateEvents() {
    super.delegateEvents(...arguments);
    for (const actionView of Array.from(this.actionViews)) {
      actionView.delegateEvents();
    }
  }

  undelegateEvents() {
    // @ts-expect-error TS(2339): Property 'undelegateEvents' does not exist on type... Remove this comment to see the full error message
    super.undelegateEvents(...arguments);
    for (const actionView of Array.from(this.actionViews)) {
      actionView.undelegateEvents();
    }
  }

  remove() {
    this.removeActionViews();
    return super.remove(...arguments);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setHighlight(id: any) {
    let action, oldAction, view;
    if (id === this.highlight) {
      return;
    }

    if (
      this.highlight &&
      (oldAction = this.collection.get(this.highlight)) != null
    ) {
      view = this._viewForAction(oldAction);
      view.setHighlighted(false);
    }

    this.highlight = id;

    if (this.highlight && (action = this.collection.get(this.highlight))) {
      view = this._viewForAction(action);
      view.setHighlighted(true);
    }
  }
}
